import { CHECKOUT_API_URL } from "../config/site";
import { getCartItemFiles } from "../cart/cartFileStore";

function dataUrlToFile(dataUrl, fileName) {
  const [header, base64Data] = dataUrl.split(",");
  const mimeMatch = header.match(/data:(.*?);base64/);
  const mimeType = mimeMatch?.[1] || "image/png";
  const binary = atob(base64Data);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return new File([bytes], fileName, { type: mimeType });
}

async function getCheckoutFiles(item) {
  const storedFiles = await getCartItemFiles(item.cartItemId);
  const generatedFiles = (item.assets || [])
    .filter((asset) => asset.preview && asset.includedInOrder)
    .map((asset, index) =>
      dataUrlToFile(asset.preview, asset.fileName || `pieza_${index + 1}.png`)
    );

  return [...storedFiles, ...generatedFiles];
}

function stripPreviewData(item) {
  return {
    ...item,
    assets: (item.assets || []).map(({ preview, ...asset }) => asset),
  };
}

export async function CartCheckout({ email, items, totals }) {
  const formData = new FormData();

  const checkoutItems = items.map(stripPreviewData);

  formData.append("email", email);
  formData.append("items", JSON.stringify(checkoutItems));
  formData.append("totals", JSON.stringify(totals));

  for (const item of items) {
    if (item.tempFiles?.length) {
      continue;
    }

    const storedFiles = await getCartItemFiles(item.cartItemId);
    const requiredStoredFiles = (item.assets || []).filter(
      (asset) => asset.kind === "uploaded_image" && asset.includedInOrder
    );
    const files = await getCheckoutFiles(item);

    if (storedFiles.length < requiredStoredFiles.length) {
      throw new Error(
        [
          "Faltan imagenes de un producto.",
          `Producto: ${item.productName || item.productId}`,
          `Esperadas: ${requiredStoredFiles.length}`,
          `Encontradas: ${storedFiles.length}`,
          `ID: ${item.cartItemId}`,
        ].join(" ")
      );
    }

    files.forEach((file) => {
      formData.append("orderFiles[]", file, file.name);
      formData.append("fileCartItemIds[]", item.cartItemId);
    });
  }

  const response = await fetch(`${CHECKOUT_API_URL}/checkout-cart.php`, {
    method: "POST",
    body: formData,
  });

  const text = await response.text();

  let data;

  try {
    data = JSON.parse(text);
  } catch (error) {
    console.error("Respuesta PHP no JSON:", text);
    throw new Error("Error PHP. Revisa la respuesta del servidor.");
  }

  if (!response.ok || !data.ok) {
    throw new Error(data.error || "No se pudo crear el checkout.");
  }

  return data;
}
